"use strict";
/**
 * This file contains constants that are used across the component library
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentSizeToBodyTextSizeMap = void 0;
/**
 *  This is the map of component size to body text size (visualAppearance)
 */
exports.componentSizeToBodyTextSizeMap = {
    l: 'body-one',
    m: 'body-two',
    s: 'body-three',
    xs: 'body-four',
};
